import type { ReactNode } from 'react';
import s from './DrawerFooter.module.css';

export interface DrawerFooterProps {
  /** Ações secundárias, encostadas à esquerda (links, Excluir, «marcar todos»). */
  start?: ReactNode;
  /** Ações principais, à direita — um único botão primário (FR-131). */
  children?: ReactNode;
}

/**
 * Conteúdo padrão do `footer` do `Drawer`: dois grupos com o mesmo gap do
 * design system. Use em vez de montar o rodapé tela a tela.
 */
export function DrawerFooter({ start, children }: DrawerFooterProps) {
  return (
    <div className={s.footer} data-testid="drawer-footer">
      {start != null && start !== false ? <span className={s.inicio}>{start}</span> : null}
      {children != null && children !== false ? <span className={s.acoes}>{children}</span> : null}
    </div>
  );
}
